 
 
 <nb-alert style="background-color:#FFFBA4;"  *ngIf="authService.currentTariff?.isFree" status="warning">
 	<p style="margin:0; color:#000;"><strong>Ви знаходитесь у безкоштовній демо-версії платформи!</strong></p>
 	<p style="margin:0; margin-top:5px; color:#000;" >Вам доступні: Максимум 5 глядачів трансляцій. 1 година трансляції. 1 година завантажених відео. 1 година ретрансляцій. Ретрансляції: 1 потік. Незмінна ціна квитка 10 грн.</p>
  </nb-alert>

 
 
 
 <nb-alert *ngIf="authService.blockedUser" status="warning">Щоб дізнатися причину і відновити роботу облікового запису зверніться за адресою <a href="mailto:moder@livestream.ua">moder@livestream.ua</a> </nb-alert>

 <nb-alert *ngIf="authService.blockedByPayment" status="warning">Дію облікового запису призупинено. Необхідно підключити тариф.</nb-alert>




